import {
  Box,
  Button,
  Grid,
  Pagination,
  Paper,
  Table,
  TableContainer,
  TableHead,
  Typography,
} from "@mui/material";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { blueGrey, grey, yellow } from "@mui/material/colors";
import { Fragment, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { CompanyPartHeader } from "../../components/PartHeader";
import SelectBox from "../../components/SelectBox";
import ConfirmDialog from "../../components/dialog/ConfirmDialog";
import useInputObject from "../../hooks/useInputObject";
import {
  deleteCommodityOwner,
  downloadCommodityOwnerPrintInfo,
  getCommodityOwnerInfo,
} from "../../http/api/CommodityOwnerAPI";
import { formatCommodityOwnerCd, formatPostalCode } from "../../utils/utils";
import { CompanyTitledPage } from "../TitledPage";
import SearchForm from "./SearchForm";
import LoadingModal from "../../components/LoadingModal";
import PrintPreview from "../invoice/PrintManagePage/PrintPreview";

const infoTableCellSx = {
  fontSize: 17,
};

const CommodityOwnerPage = () => {
  const columns = [
    "荷主CD",
    "荷主名",
    // "フリガナ",
    // "仕入先",
    "郵便番号",
    "住所",
    "TEL",
    "FAX",
    // "メール",
    // "原票種別",
    "集計区分",
    // "農協コード",
    // "系統団体名",
    // "締日",
    // "手数料率",
    // "運賃",
    // "送金手数料コード",
    "事業者登録番号",
    // "帳合先コード",
    "",
  ];
  const [listCommodityOwner, setListCommodityOwner] = useState([]);
  const [APIListCommodityOwner, setAPIListCommodityOwner] = useState([]);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [isLoading, setLoading] = useState(false);

  const navigate = useNavigate();
  const searchData = useInputObject({
    commodityOwner: "",
  });
  const printPreview = useInputObject({
    open: false,
    url: "",
  });

  const deleteDialog = useInputObject({ open: false, deleteItem: {} });

  useEffect(() => {
    getListCommodityOwner();
  }, []);

  useEffect(() => {
    setListCommodityOwner(APIListCommodityOwner);
  }, [APIListCommodityOwner]);

  async function getListCommodityOwner() {
    try {
      setLoading(true);
      const response = await getCommodityOwnerInfo({});
      setAPIListCommodityOwner(response.listCommodityOwnerInfo);
      setPage(1);
    } catch {
      setAPIListCommodityOwner([]);
    } finally {
      setLoading(false);
    }
  }

  async function handleSearch(searchData) {
    try {
      const newListCommodityOwner = APIListCommodityOwner.filter(
        (commodityOwner) =>
          commodityOwner.commodityOwnerCd == searchData.commodityOwner ||
          commodityOwner.commodityOwnerName.includes(searchData.commodityOwner)
      );
      setListCommodityOwner(newListCommodityOwner);
      setPage(1);
    } catch {
      setListCommodityOwner([]);
    }
  }

  async function onClickDeleteCommodityOwner(data) {
    deleteDialog.updates({ open: true, deleteItem: data });
  }

  async function deleteSelectedCommodityOwner() {
    const deleteCommodityOwnerCd =
      deleteDialog.Value.deleteItem.commodityOwnerCd;
    const userDelete = 1; //TODO : JWT
    const deleteParams = {
      commodityOwnerCd: deleteCommodityOwnerCd,
      updatedId: userDelete,
    };
    try {
      setLoading(true);
      await deleteCommodityOwner(deleteParams);
      alert("荷主を削除しました。");
      const newListCommodityOwner = APIListCommodityOwner.filter(
        (commodityOwner) =>
          !(commodityOwner.commodityOwnerCd === deleteCommodityOwnerCd)
      );
      setAPIListCommodityOwner(newListCommodityOwner);
    } catch {
      alert("荷主を削除できませんでした。");
    } finally {
      setLoading(false);
    }
  }

  async function printCommodityOwner() {
    try {
      //　ローディング　表示
      setLoading(true);
      // request to server 
      // request body 宣言
      const requestBody = {};
      // download 結果　受け取る
      const result = await downloadCommodityOwnerPrintInfo(requestBody);
      //印刷情報設定
      if (result) {
        const blob = new Blob([result], {
          type: "application/pdf",
          encoding: "UTF-8",
        });
        const fileUrl = URL.createObjectURL(blob);
        printPreview.updates({ open: true, url: fileUrl });
      }
    } catch (error) {

    }
    finally {
      //　ローディング　非表示
      setLoading(false);
    }

  };

  useEffect(() => {
    setPage(1);
  }, [itemsPerPage]);

  return (
    <Fragment>
      <CompanyTitledPage title="荷主管理">
        <SearchForm searchData={searchData} search={handleSearch} />

        <CompanyPartHeader>
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            my={1}
          >
            <Grid item xs="auto">
              <Typography fontWeight="bold" fontSize={20}>
                検索一覧
                {listCommodityOwner.length > 0
                  ? `（件数：${listCommodityOwner.length}）`
                  : ""}
              </Typography>
            </Grid>
            <Grid item xs="auto">
            <Button
                variant="outlined"
                onClick={printCommodityOwner}
              >

                荷主一覧印刷
              </Button>
              <Button
                variant="outlined"
                onClick={() => navigate(`/company/commodity_owner_insert/`)}
              >
                荷主を登録
              </Button>
            </Grid>
          </Grid>
        </CompanyPartHeader>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                {columns.map((columnName, i) => {
                  return (
                    <TableCell
                      key={`${columnName}_${i}`}
                      sx={{ ...infoTableCellSx, backgroundColor: grey[100] }}
                    >
                      {columnName}
                    </TableCell>
                  );
                })}
              </TableRow>
            </TableHead>
            <TableBody>
              {listCommodityOwner
                .slice(
                  (page - 1) * itemsPerPage,
                  (page - 1) * itemsPerPage + itemsPerPage
                )
                .map((data, index) => (
                  <TableRow
                    key={index}
                    sx={{
                      "&:hover": {
                        backgroundColor: blueGrey[50],
                      },
                    }}
                  >
                    {/* 荷主Cd */}
                    <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                      {formatCommodityOwnerCd(data.commodityOwnerCd)}
                    </TableCell>
                    {/* 荷主名 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 370 }}>
                      {data.commodityOwnerName}
                    </TableCell>
                    {/* 郵便番号 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {formatPostalCode(data.postCode)}
                    </TableCell>
                    {/* 住所 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 450 }}>
                      {data.address}
                    </TableCell>
                    {/* TEL */}
                    <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.tel}
                    </TableCell>
                    {/* FAX */}
                    <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.fax}
                    </TableCell>
                    {/* 原票種別 */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.salesRecordTypeName}
                    </TableCell> */}
                    {/* 荷主集計区分 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 100 }}>
                      {data.commodityOwnerTotalDivisionName}
                    </TableCell>
                    {/* 農協コード */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.jaCode}
                    </TableCell> */}
                    {/* 系統団体名 */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.relatedGroupName}
                    </TableCell> */}
                    {/* 締日グループ */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 120 }}>
                      {data.closingDateGroupContent?.replace("99", "月末")}
                    </TableCell> */}
                    {/* 手数料率 */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.feeRate}
                    </TableCell> */}
                    {/* 運賃 */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.shippingFee}
                    </TableCell> */}
                    {/* 事業者登録番号 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.businessRegistrationNo}
                    </TableCell>
                    {/* 帳合先コード */}
                    {/* <TableCell sx={{ ...infoTableCellSx, width: 150 }}>
                      {data.balanceAccountCd}
                    </TableCell> */}

                    {/* 編集・削除 */}
                    <TableCell sx={{ ...infoTableCellSx, width: 70 }}>
                      <Box display="flex" justifyContent="flex-end">
                        <Button
                          variant="outlined"
                          sx={{ marginRight: 3 }}
                          onClick={() => {
                            navigate(`/company/commodity_owner_edit/`, {
                              state: {
                                commodityOwnerInfo: data,
                              },
                            });
                          }}
                        >
                          編集
                        </Button>
                        <Button
                          variant="outlined"
                          color="error"
                          onClick={() => {
                            onClickDeleteCommodityOwner(data);
                          }}
                        >
                          削除
                        </Button>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <Grid container display="flex" justifyContent="space-between" mt={5}>
          <Grid item xs={2}>
            <SelectBox
              data={[10, 25, 50].map((x) => {
                return {
                  key: x,
                  value: x,
                };
              })}
              onChange={(e) => {
                setItemsPerPage(e.target.value);
              }}
              value={itemsPerPage}
              sx={{ width: 100 }}
              label={"表示件数　"}
              nullable={false}
            />
          </Grid>
          <Grid item xs={8} display="flex" justifyContent="center">
            <Pagination
              count={
                Math.floor((listCommodityOwner.length - 1) / itemsPerPage) + 1
              }
              page={page}
              onChange={(e, newPage) => {
                setPage(newPage);
              }}
              variant="outlined"
              shape="rounded"
            />
          </Grid>
          <Grid item xs={2}></Grid>
        </Grid>

        <ConfirmDialog
          open={deleteDialog.Value.open}
          onClose={() => deleteDialog.update("open", false)}
          title="荷主を削除確認"
          action={deleteSelectedCommodityOwner}
          buttonAcceptLabel="削除"
        >
          <Box marginTop={2} marginBottom={1}>
            <Typography>以下の荷主を削除します。</Typography>
            <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
              <Typography>
                荷主Cd：{deleteDialog.Value.deleteItem.commodityOwnerCd}
              </Typography>
              <Typography>
                荷主名：{deleteDialog.Value.deleteItem.commodityOwnerName}
              </Typography>
            </Box>
          </Box>
        </ConfirmDialog>

        <LoadingModal label="取得中" open={isLoading} />
        <PrintPreview printPreview={printPreview} />
      </CompanyTitledPage>
    </Fragment>
  );
};
export default CommodityOwnerPage;
